import styled from 'styled-components';
import { COMMON } from './constants';
import sx from './sx';
const Details = styled.details.withConfig({
  displayName: "Details",
  componentId: "ssy9qz-0"
})(["& > summary{list-style:none;}& > summary::-webkit-details-marker{display:none;}", " ", ";"], COMMON, sx);
Details.displayName = 'Details';
export default Details;